import { Routes } from '@angular/router';
import { Route } from './core/route.service';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationGuard } from './core/authentication/authentication.guard';

export const routes: Routes = Route.withShell([
  {
    path: '',
    children: [
      /*{
        path: '',
        loadComponent: () => {
          return import('./loading/loading_component/loading.component').then(
            (m) => m.LoadingComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        //canActivate: [AuthenticationGuard],
      },*/
      {
        path: 'map-edit',
        loadComponent: () => {
          return import('./map-edit/map-edit.component').then(
            (m) => m.MapEditComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        //  canActivate: [AuthenticationGuard],
      },
      {
        path: 'map-view',
        loadComponent: () => {
          return import('./map-view/map-view.component').then(
            (m) => m.MapViewComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        // canActivate: [AuthenticationGuard],
      },
      {
        path: 'map-show',
        loadComponent: () => {
          return import('./map-show/map-show.component').then(
            (m) => m.MapShowComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        // canActivate: [AuthenticationGuard],
      }
    ]
  }
]);
